<template>
    <div class="modal-wrapper" :class="{ hide: !show, blur, important }">
        <jump-transition>
            <div v-if="show" class="modal" :class="{ absolute }">
                <slot name="absolute"></slot>
                <div v-if="!absolute" class="content flex-column-gap">
                    <slot name="content"></slot>
                </div>
                <div v-if="!absolute" class="bottom">
                    <slot name="footer"></slot>
                </div>
            </div>
        </jump-transition>
        <fade-transition>
            <div v-if="show" class="backdrop"></div>
        </fade-transition>
    </div>
</template>

<script>
import JumpTransition from '@/components/transitions/JumpTransition.vue';
import FadeTransition from '@/components/transitions/FadeTransition.vue';

export default {
    name: 'popup-modal',
    components: {
        JumpTransition,
        FadeTransition
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        blur: {
            type: Boolean,
            default: false
        },
        absolute: {
            type: Boolean,
            default: false
        },
        important: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        }
    },
    watch: {
        '$route.fullPath': function() {
            // werkt niet, check maken die popups weghaalt wanneer je weg navigeert
            // zodat ze niet te lang blijven leven op de achtergrond

            // if(this.$route.fullPath === this.createdPath) return;
            // console.log('CLOSE POPUP')
            // this.$nextTick(() => {
            //     this.showModal = false;
            // })
        }
    },
}
</script>

<style lang="scss">

.modal-wrapper { 
    position: absolute;
    overflow: hidden;
    z-index: 200;
    isolation: isolate;

    &.important {
        z-index: 300;
    }

    &.hide {
        pointer-events: none;
    }

    &.blur .backdrop {
        backdrop-filter: blur(10px);
    }

    .backdrop {
        position: fixed;
        inset: 0;
        background-color: #00000030;
        pointer-events: none;
    }

    .modal {
        position: fixed;
        width: calc(var(--absolute-width) - 8vw - 52px);
        margin-inline: 4vw;
        top: 50%;
        translate: 0 -50%;
        background-color: #182118ee;
        border-radius: 20px;
        padding: 26px;

        display: flex;
        flex-direction: column;
        gap: 16px;
        z-index: 1;

        &.absolute {
            background-color: transparent;
            inset: 0;
            translate: 0;
        }

        .content {
            color: #f1f1f1;
            .message {
                text-align: center;

                &.secundary {
                    color: #e8e8e8;
                }
            }
        }

        .bottom {
            display: flex;
            gap: 12px;
        }

    }
}

@keyframes fade-in {
    from {
        background-color: #00000000;
    } to {
        background-color: #00000020;
    }
}

</style>